module.exports = __webpack_public_path__ + "img/pr.0811a051.svg";